export default class Cat {
  public name: string

  constructor(name: string){
    this.name = name
  }
}